import { render, staticRenderFns } from "./UserRoleMixin.vue?vue&type=template&id=110f9ba8&lang=pug&"
import script from "./UserRoleMixin.vue?vue&type=script&lang=ts&"
export * from "./UserRoleMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports